import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Button } from '../ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

const ANIMAL_TYPES = [
  { value: 'all', label: 'Tümü' },
  { value: 'dog', label: 'Köpek' },
  { value: 'cat', label: 'Kedi' },
];
const VAT_RATES = [
  { value: '0', label: '%0' },
  { value: '1', label: '%1' },
  { value: '10', label: '%10' },
  { value: '20', label: '%20' },
];

export const OperationForm = ({ form, setForm, onSubmit, submitLabel }) => (
  <div className="space-y-3 mt-3">
    <div className="space-y-1">
      <Label className="text-xs">{'İşlem Adı'}</Label>
      <Input value={form.name} onChange={e => setForm(p => ({ ...p, name: e.target.value }))}
        className="h-10 text-sm bg-[#F2F2F7] border-0 rounded-xl" data-testid="op-name-input" />
    </div>
    <div className="grid grid-cols-2 gap-2">
      <div className="space-y-1">
        <Label className="text-xs">{`Tür`}</Label>
        <Select value={form.type} onValueChange={v => setForm(p => ({ ...p, type: v }))}>
          <SelectTrigger className="h-10 text-sm bg-[#F2F2F7] border-0 rounded-xl"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="vaccine">{`Aşı`}</SelectItem>
            <SelectItem value="treatment">Tedavi</SelectItem>
            <SelectItem value="service">Hizmet</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="space-y-1">
        <Label className="text-xs">{`Hasta Türü`}</Label>
        <Select value={form.animal_type} onValueChange={v => setForm(p => ({ ...p, animal_type: v }))}>
          <SelectTrigger className="h-10 text-sm bg-[#F2F2F7] border-0 rounded-xl"><SelectValue /></SelectTrigger>
          <SelectContent>
            {ANIMAL_TYPES.map(a => <SelectItem key={a.value} value={a.value}>{a.label}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
    </div>
    <div className="grid grid-cols-2 gap-2">
      <div className="space-y-1">
        <Label className="text-xs">{`Satış Fiyatı (TL)`}</Label>
        <Input type="number" placeholder="0" value={form.default_price}
          onChange={e => setForm(p => ({ ...p, default_price: e.target.value }))}
          className="h-10 text-sm bg-[#F2F2F7] border-0 rounded-xl" data-testid="op-price-input" />
      </div>
      {form.type === 'vaccine' && (
        <div className="space-y-1">
          <Label className="text-xs">{`Tekrar Süresi (Gün)`}</Label>
          <Input type="number" placeholder="365" value={form.default_interval_days}
            onChange={e => setForm(p => ({ ...p, default_interval_days: e.target.value }))}
            className="h-10 text-sm bg-[#F2F2F7] border-0 rounded-xl" />
        </div>
      )}
    </div>
    <div className="space-y-1">
      <Label className="text-xs">{`İşlem Süresi (dk)`}</Label>
      <Input type="number" placeholder="30" min="5" step="5" value={form.duration_minutes || ''}
        onChange={e => setForm(p => ({ ...p, duration_minutes: e.target.value }))}
        className="h-10 text-sm bg-[#F2F2F7] border-0 rounded-xl" data-testid="op-duration-input" />
    </div>
    <div className="space-y-1">
      <Label className="text-xs font-medium text-gray-700">{`KDV Oranı`} <span className="text-red-500">*</span></Label>
      <Select value={String(form.vat_rate ?? '')} onValueChange={v => setForm(p => ({ ...p, vat_rate: v }))}>
        <SelectTrigger className="h-10 text-sm bg-[#F2F2F7] border-0 rounded-xl" data-testid="op-vat-rate"><SelectValue placeholder="KDV oranı seçiniz" /></SelectTrigger>
        <SelectContent>
          {VAT_RATES.map(r => <SelectItem key={r.value} value={r.value}>{r.label}</SelectItem>)}
        </SelectContent>
      </Select>
    </div>
    <Button onClick={onSubmit} className="w-full bg-[#6b6de3] hover:bg-[#5658c4] rounded-full" data-testid="op-submit-btn">{submitLabel}</Button>
  </div>
);
